import { render } from "./PropProd.vue?vue&type=template&id=0b6cf746&scoped=true"
import script from "./PropProd.vue?vue&type=script&lang=js"
export * from "./PropProd.vue?vue&type=script&lang=js"

import "./PropProd.vue?vue&type=style&index=0&id=0b6cf746&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6cf746"]])

export default __exports__